import Lottie from "lottie-react";
import React from "react";
import truck from "../../assets/json/moving_truck.json";
import styles from "./Loader.module.scss";
import { useSelector } from "react-redux";
import Logo from "../../assets/images/logo.png";

export default function Loader() {
  const isLoading = useSelector((state) => state.loader.isLoading);
  return (
    <div
      className="fixed top-0 left-0 w-full h-screen justify-content-center bg-white-alpha-90 z-5 align-items-center"
      style={{ display: isLoading ? "flex" : "none" }}
    >
      <img src={Logo} alt="Shah Transport" width={180} height={100}/>
      {/* <div className="col-7 lg:w-4 relative">
        <h4 className={styles.logoText}>
          Shah <br />
          <span className="pl-5">Transport</span>
        </h4>
        <Lottie animationData={truck} loop={true} />
      </div> */}
    </div>
  );
}
